const cacheKey = () => `${process.env.NODE_ENV}_uedp_user`

/**
 * Sets user details in localStorage
 * @param user Details of the logged-in user
 */
export function setCachedUser(user) {
	try {
		localStorage.setItem(cacheKey(), JSON.stringify(user))
	} catch (err) {
		console.error(err)
	}
}

/**
 * Removes user details from localStorage
 */
export async function removeCachedUser() {
	try {
		localStorage.removeItem(cacheKey())
	} catch (err) {
		console.error(err)
	}
}

/**
 * Retrieves user details from localStorage
 */
export function getCachedUser() {
	try {
		const userString = localStorage.getItem(cacheKey())
		return userString ? JSON.parse(userString) : undefined
	} catch (err) {
		return undefined
	}
}
